import axios from 'axios';

const apiUrl = process.env.KMB_API_URL;
const headers = {
  'Content-Type': 'application/json',
};

const getProjectId = () => {
  const protocol = window.location.protocol;
  const hostName = window.location.hostname;
  const domain = `${protocol}//${hostName}`;
  const webhookUrl = `${apiUrl}/webhook/project_find_by.json`;

  return axios.post(webhookUrl, { domain }, { headers });
};

export default {
  getProjectId,
};



// WEBPACK FOOTER //
// ./src/helpers/request/domain.js